import type { TranslationDict } from '../en';

const da: TranslationDict = {
  'header.buy': 'Køb',
  'header.sell': 'Sælg',
  'spend.label': 'Du bruger',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'Du modtager',
  'payment.label': 'Betalingsmetode',
  'payment.select': 'Vælg',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Ingen betalingsmetoder tilgængelige for dette par',
  'wallet.label': 'Modtagende wallet-adresse',
  'wallet.placeholderBuy': 'Indtast din modtageradresse',
  'wallet.placeholderSell': 'Indtast din afsenderadresse',
  'wallet.validating': 'Validerer adresse...',
  'wallet.invalid': 'Indtast en gyldig wallet-adresse',
  'wallet.invalidServer': 'Ugyldig wallet-adresse',
  'cta.buy': 'Køb {crypto}',
  'cta.sell': 'Sælg {crypto}',
  'cta.gettingPrice': 'Finder bedste pris...',
  'cta.processing': 'Behandler...',
  'footer.poweredBy': 'Drevet af ',
  'footer.brand': 'NowRamp',
  'rate.title': 'Kursoversigt',
  'rate.close': 'Luk',
  'rate.updatesIn': 'Kursen opdateres om 00:{seconds}',
  'rate.noQuote': 'Ingen tilbud tilgængeligt',
  'rate.exchangeRate': 'Vekselkurs',
  'rate.processingFee': 'Behandlingsgebyr',
  'rate.networkFee': 'Netværksgebyr',
  'rate.provider': 'Udbyder',
  'toast.orderCreated': 'Ordre oprettet',
  'toast.redirecting': 'Omdirigerer til betaling...',
  'toast.orderFailed': 'Ordre mislykkedes',
  'toast.couldNotCreate': 'Kunne ikke oprette ordre',
  'toast.quoteError': 'Tilbudsfejl',
  'toast.noProviders': 'Ingen udbydere',
  'toast.somethingWrong': 'Noget gik galt',
  'error.amountZero': 'Beløbet skal være større end 0',
  'error.minAmountFiat': 'Minimumsbeløbet er {min} {currency}',
  'error.minAmountCrypto': 'Minimumsbeløbet er {min} {currency}',
  'error.noProviders': 'Ingen udbydere tilgængelige for denne kombination',
  'error.currencyUnavailableBuy': 'Denne valuta er ikke tilgængelig til køb',
  'error.currencyUnavailableSell': 'Denne valuta er ikke tilgængelig til salg',
  'parity.info': 'Du vil blive opkrævet for {receiveAmount} {crypto}, resten op til {spendAmount} {fiat} vil blive krediteret til din {partner}-konto',
  'redirect.secureBadge': 'Sikker betaling',
  'redirect.title': 'Fortsæt betaling',
  'redirect.description': 'Du vil blive omdirigeret til {gateway} for at fuldføre din betaling.',
  'redirect.countdown': 'Omdirigerer om {seconds}...',
  'redirect.openTab': 'Åbn ACH i ny fane',
  'redirect.cancel': 'Annuller',
  'checkout.noOrder': 'Ingen ordre fundet',
  'checkout.goBack': 'Gå tilbage',
  'checkout.expired': 'Betaling er udløbet',
  'checkout.expiredDesc': 'Sessionen er udløbet. Prøv venligst igen.',
  'checkout.startOver': 'Start forfra',
  'checkout.cancel': 'Annuller',
  'checkout.loading': 'Indlæser betaling...',
  'checkout.iframeTitle': 'Udbyder-betaling',
  'checkout.widgetTitle': 'Betalingskasse',
  'checkout.unknownMethod': 'Ukendt betalingsmetode',
  'processing.default': 'Behandler din ordre...',
  'processing.pending': 'Venter på betalingsbekræftelse...',
  'processing.active': 'Behandler din transaktion...',
  'processing.generic': 'Behandler...',
  'processing.checkingStatus': 'Tjekker status...',
  'processing.orderId': 'Ordre-ID',
  'processing.provider': 'Udbyder',
  'processing.amount': 'Beløb',
  'processing.receiving': 'Modtager',
  'processing.network': 'Netværk',
  'processing.toAddress': 'Til adresse',
  'processing.usuallyMinutes': 'Dette tager normalt et par minutter.',
  'processing.safeToClose': 'Du kan roligt lukke denne side — vi sender dig en e-mail, når det er fuldført.',
  'complete.buyTitle': 'Køb fuldført!',
  'complete.sellTitle': 'Salg fuldført!',
  'complete.buyDesc': 'Din {crypto} er blevet sendt til din wallet.',
  'complete.sellDesc': 'Din {fiat}-udbetaling behandles.',
  'complete.amountBuy': 'Modtaget beløb',
  'complete.amountSell': 'Solgt beløb',
  'complete.paidBuy': 'Betalt beløb',
  'complete.paidSell': 'Udbetalingsbeløb',
  'complete.network': 'Netværk',
  'complete.wallet': 'Wallet',
  'complete.transaction': 'Transaktion',
  'complete.provider': 'Udbyder',
  'complete.orderId': 'Ordre-ID',
  'complete.completed': 'Fuldført',
  'complete.viewExplorer': 'Se på Explorer',
  'complete.done': 'Færdig',
  'errorStep.failed': 'Betaling mislykkedes',
  'errorStep.cancelled': 'Ordre annulleret',
  'errorStep.expired': 'Ordre udløbet',
  'errorStep.refunded': 'Ordre refunderet',
  'errorStep.unknown': 'Noget gik galt',
  'errorStep.failedBuy': 'Din betaling kunne ikke behandles. Prøv venligst igen eller brug en anden betalingsmetode.',
  'errorStep.failedSell': 'Dit salg kunne ikke behandles. Prøv venligst igen.',
  'errorStep.cancelledBuy': 'Din ordre blev annulleret. Ingen betaling blev behandlet.',
  'errorStep.cancelledSell': 'Dit salg blev annulleret. Ingen krypto blev overført.',
  'errorStep.expiredBuy': 'Din ordre er udløbet. Start venligst et nyt køb.',
  'errorStep.expiredSell': 'Din ordre er udløbet. Start venligst et nyt salg.',
  'errorStep.refundedBuy': 'Din betaling er blevet refunderet. Midlerne bør vises på din konto inden for 5-10 hverdage.',
  'errorStep.refundedSell': 'Din krypto er blevet returneret. Midlerne bør snart vises i din wallet.',
  'errorStep.genericDesc': 'Der opstod en uventet fejl. Prøv venligst igen.',
  'errorStep.orderId': 'Ordre-ID',
  'errorStep.tryAgain': 'Prøv igen',
  'errorStep.startOver': 'Start forfra',
  'errorStep.return': 'Tilbage',
  'errorStep.needHelp': 'Brug for hjælp? Kontakt ',
  'errorStep.reference': 'Reference: {orderId}',
  'confirm.buyTitle': 'Bekræft køb',
  'confirm.sellTitle': 'Bekræft salg',
  'confirm.loading': 'Indlæser...',
  'confirm.provider': 'Udbyder',
  'confirm.youPay': 'Du betaler',
  'confirm.youSell': 'Du sælger',
  'confirm.youReceive': 'Du modtager',
  'confirm.wallet': 'Wallet',
  'confirm.network': 'Netværk',
  'confirm.refundAddress': 'Refusionsadresse',
  'confirm.parityNote': 'Det opkrævede beløb fra udbyderen kan variere. Resten op til {amount} {crypto} vil blive krediteret til din {partner}-konto.',
  'confirm.processing': 'Behandler...',
  'confirm.confirmPay': 'Bekræft og betal',
  'confirm.confirmSell': 'Bekræft og sælg',
  'confirm.payout': '{currency}-udbetaling',
  'modal.selectFiat': 'Vælg fiat-valuta',
  'modal.selectCrypto': 'Vælg kryptovaluta',
  'modal.choosePayment': 'Vælg betalingsmetode',
  'modal.selectCountry': 'Vælg dit land',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Populære',
  'modal.recommended': 'Anbefalede',
  'modal.noCurrencies': 'Ingen valutaer fundet',
  'modal.noPaymentMethods': 'Ingen betalingsmetoder fundet',
  'modal.noCountries': 'Ingen lande fundet',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'Placering',
  'settings.darkMode': 'Mørk tilstand',
  'settings.privacy': 'Privatlivspolitik',
  'settings.terms': 'Vilkår for brug',
  'settings.language': 'Sprog',

  // ─── Additional ───
  'modal.chooseRamp': 'Vælg Ramp',
  'modal.bestPrice': 'Bedste pris',
  'modal.noQuotes': 'Ingen tilbud tilgængelige for denne forespørgsel',
  'modal.noProvidersFound': 'Ingen udbydere fundet',
  'payment.unavailableFor': 'Ingen betalingsmetoder tilgængelige for {currency}',
  'skeleton.poweredBy': 'Drevet af NowRamp',
  'error.createOrderFailed': 'Kunne ikke oprette ordre',
  'errorStep.returnToMerchant': 'Tilbage til forhandler',
  'confirm.cryptoOnNetwork': '{crypto} på {network}',
  'payment.name.card': 'Kort',
  'payment.name.bankTransfer': 'Bankoverførsel',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default da;
